import { HTTP } from '@/http-common'

function getBillTemplate (billTemplateId) {
  return HTTP.get('/bill-templates/' + billTemplateId)
}

function addBillTemplate (billTemplateData) {
  let data = JSON.stringify(billTemplateData)

  return HTTP.post('/bill-templates', data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function updateBillTemplate (billTemplateData) {
  let data = JSON.stringify(billTemplateData)

  return HTTP.put('/bill-templates/' + billTemplateData.id, data, {
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
}

function deleteBillTemplate (billTemplateId) {
  return HTTP.delete('/bill-templates/' + billTemplateId)
}

export { getBillTemplate, addBillTemplate, updateBillTemplate, deleteBillTemplate }



// WEBPACK FOOTER //
// ./src/services/bill_template.service.js